export const CHAIN_INFO = {
  1: 'Ethereum Main Network',
  3: 'Ropsten Test Network',
  4: 'Rinkeby Test Network',
  5: 'Goerli Test Network',
  42: 'Kovan Test Network',
  56: 'Binance Smart Chain',
  1337: 'Ganache',
  137: 'Polygon',
  43114: 'Avalanche',
  1666600000: 'Harmony',
  250: 'Fantom',
  1285: 'Moonriver',
};
